import { render } from "./new2copy.vue?vue&type=template&id=b8dc9d76&scoped=true"
import script from "./new2copy.vue?vue&type=script&lang=js"
export * from "./new2copy.vue?vue&type=script&lang=js"

import "./new2copy.vue?vue&type=style&index=0&id=b8dc9d76&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-agent\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8dc9d76"]])

export default __exports__